<template>
  <div class="advice">
    <div class="topImg">
      <img :src="bg" style="width:100%" alt="">
      <div class="intro">
        <div class="title">系统建议</div>
        <div class="detail">请描述您的建议，我们将及时进行解决</div>
      </div>
    </div>
    <van-field
      v-model="form.content"
      rows="4"
      type="textarea"
      maxlength="200"
      placeholder="请输入您要反馈的问题(5-200字以内)"
      show-word-limit
    />
    <div class="userInfo">
      <van-cell-group>
        <van-field v-model="form.name" maxlength="20" label="姓名" placeholder="请输入姓名">
          <template #label>
            <span class="custom-label">姓名</span>
          </template>
          <template #right-icon>
            <img :src="closeIcon" alt="" class="custom-icon" v-show="form.name" @click="clear('name')">
          </template>
        </van-field>
        <van-field v-model="form.phone" type="tel" maxlength="11" label="联系电话" placeholder="请输入联系电话">
          <template #label>
            <span class="custom-label">联系电话</span>
          </template>
          <template #right-icon>
            <img :src="closeIcon" alt="" class="custom-icon" v-show="form.phone" @click="clear('phone')">
          </template>
        </van-field>
        <van-field is-link readonly @click="showQuePicker = true " v-show="questionList.length">
          <template #label>
            <span class="custom-label">选择问卷</span>
          </template>
          <template #input>
            <span class="custom-value" v-if="form.aname">{{ form.aname}}</span>
            <span class="custom-placeholder" v-else>选择有疑问的问卷</span>
          </template>
        </van-field>
        <van-popup v-model="showQuePicker" position="bottom">
            <van-picker
              show-toolbar
              value-key="name"
              :columns="questionList"
              @confirm="confirmQue"
              @cancel="showQuePicker = false"
            />
          </van-popup>
      </van-cell-group>
    </div>
    <div class="submitButton">
      <div class="custom-button" @click="onSubmit">
        提交
      </div>
    </div>
  </div>
</template>

<script>
import { insertAdvice } from '../../api/advice'
import { getListByUid } from '../../api/anser'
import store from '../../store/index'
export default {
  created() {
    const userInfo = store.getters.userInfo
    if(userInfo) {
      this.$set(this.form, 'uid', userInfo.user.id)
      this.getQuestionList()
    }
  },
  data() {
    return {
      bg: require('../../assets/images/advice/bg.png'),
      closeIcon: require('../../assets/images/icon/close.png'),
      phonePattern: /^1[3456789]\d{9}$/, // 手机号正则
      showQuePicker: false,
      questionList: [],
      form: {
        name: '',
        phone: '',
        content: '',
        aid: '',
        aname: '',
        uid: ''
      },
      isRequest: false
    }
  },
  methods: {
    clear(tag) {
      this.$set(this.form, tag, '')
    },
    tips(msg) { 
      this.$notify({
        message: msg,
        duration: 1500,
      })
    },
    onSubmit() {
      if (this.isRequest) {
        return
      }
      if(!this.form.name) {
        this.tips('请输入姓名')
        return
      }
      if(!this.form.content) {
        this.tips('请填写反馈内容')
        return
      }
      if(!this.form.phone) {
        this.tips('请输入联系电话')
        return
      }
      if(!this.phonePattern.test(this.form.phone)) {
        this.tips('请输入有效的联系电话')
        return
      }
      this.isRequest = true
      insertAdvice(this.form).then(res => {
        if (res.error) {
          return
        }
        this.$dialog.alert({
          title: '提交成功',
          message: '请耐心等待3-5个工作日,并保持电话畅通,我们将会有工作人员联系您'
        }).then( () => {
          this.$router.go(-1)
        })
      }).finally( () => {
        this.isRequest = false
      })
    },
    getQuestionList() {
      getListByUid({
        pageNum: 1,
        pageSize: 300, // 不分页，所以暂时设置300 后续超出需增加
        uid: this.form.uid,
        status: 2 //代表已拒绝
      }).then(res => {
        this.questionList = res.data.list || []
      })
    },
    confirmQue(val) {
      this.$set(this.form, 'aname', val.name)
      this.$set(this.form, 'aid', Number(val.id))
      this.showQuePicker = false
    }
  }
}
</script>

<style lang="stylus">
  .advice {
    min-height: 100vh;
    padding-bottom: 30px;
    background: #F2F2F2;
    .topImg{
      height: 360px;
      position: relative;
      .intro{
        position: absolute;
        top: 200px;
        left: 40px
        color: #fff;
        .title {
          font-size: 34px;
        }
        .detail {
          margin-top: 10px;
          font-size: 22px;
          opacity: 0.7;
          font-weight: 400;
        }
      }
    }
    .userInfo {
      margin-top: 30px;
      .custom-icon {
        width: 20px;
        height: 20px;
      }
      .custom-label {
        font-size: 28px;
        color: #333333;
      }
      .custom-value {
        font-size: 14PX;
        color: #323233;
      }
      .custom-placeholder {
        color: #888888;
        font-size: 26px;
      }
    }
    .submitButton {
      margin-top: 150px;
      display: flex;
      justify-content: center
      .custom-button {
        width: 500px;
        font-size: 28px;
        height: 90px;
        color: #fff;
        // line-height: 90px;
        // text-align: center
        background: #368BFF;
        border-radius: 45px;
        display: flex;
        justify-content: center;
        align-items: center
      }
    }
  }
</style>